(function () {
    /* global twttr */

    var currentUrl;
    var _currentSlideshow;
    var slideshows = {};
    var _listicle = [
        '<li class="listicle__slide" data-beacon=\'{"p":{"mpid":"%%key%%"}}\' data-credit="%%slideCredit%%" data-id="%%slideId%%" data-index="%%keyPlus%%" data-sharingimage="%%slideImage%%" data-type="image">',
        '<div class="listicle__slide-header">',
            '<span class="listicle__slide-number">%%keyPlus%%</span>',
            '<span class="listicle__slide-title">%%slideTitle%%</span>',
        '</div>',
        '<div class="listicle__slide-content">',
            '<span class="share-bar-image-wrapper">',
                '<img class="listicle__image" src="%%slideImage%%">',
                '<div class="share-bar share-bar--instream">',
                    '<div class="share-bar__item facebook" data-type="facebook">',
                        '<a class="share-bar__item-link entry__link--omit icon-Social_Facebook" data-beacon=\'{"p":{"lnid":"share_facebook"}}\' data-pin-custom="" href="" target="_blank"></a>',
                    '</div>',
                '</div>',
            '</span>',
        '</div>',
        '<div class="listicle__slide-credits">%%slideCredit%%</div>',
        '<div class="listicle__slide-caption">%%slideCaption%%</div>',
        '</li>'
    ].join('');
    var _innerSlideshowContainer = [
        '<div data-beacon=\'{"p":{"mnid":"slideshow","lnid":"open"}}\' id="slideshow-page">',
            '<h2 class="headline__title">%%slideshowHeadline%%</h2>',
            '<!-- Slideshow Overlay Slides Container -->',
            '<ul class="listicle" data-id="%%slideshowId%%" data-length="19" id="listicle-%%slideshowId%%">',
            '</ul>',
        '</div>'
    ].join('');

    var initSlideshows = function () {
        $('.slideshow, .slideshow-thumb').each(function () {
            var $overlay;
            var slid = $(this).attr('data-slideshow-id');
            var dataUrl = $(this).attr('data-data-url');

            if ($(this).hasClass('slideshow-thumb')) {
                $overlay = $('#modal');

                slideshows[slid] = {
                    data: null,
                    slid: slid,
                    dataUrl: dataUrl,
                    slideshowOverlay: $overlay,
                    overlayTitle: $overlay.find('.headline__title'),
                    preloads: $overlay.find('.slideshow-overlay__data__preload'),
                    slideContainer: $overlay.find('.listicle'),
                    slideIndex: 1,
                    mobile: true,
                    desktop: false,
                    adCode: $(this).data('ad-code') || ""
                };
            } else {
                $overlay = $('#overlay-' + slid);

                slideshows[slid] = {
                    data: null,
                    slid: slid,
                    dataUrl: dataUrl,
                    slideshowOverlay: $overlay,
                    overlayTitle: $overlay.find('.slideshow-overlay__header__title'),
                    previewTitle: $overlay.find('.slideshow__preview__text__title'),
                    topAd: $overlay.find('.slideshow-overlay__container__ad-con__top-ad'),
                    sideAd: $overlay.find('.slideshow-overlay__container__left__side-ad'),
                    preloads: $overlay.find('.slideshow-overlay__data__preload'),
                    slideCountTotal: $overlay.find('.slideshow-overlay__container__left__nav__total').eq(0),
                    slideCount: 0,
                    slideContainer: $overlay.find('.slideshow-overlay__container__content__slide'),
                    slideCredit: $overlay.find('.slideshow-overlay__container__content__credit'),
                    slideTitle: $overlay.find('.slideshow-overlay__container__left__info__slide-title'),
                    slideCaption: $overlay.find('.slideshow-overlay__container__left__info__slide-caption'),
                    slideCounter: $overlay.find('.slideshow-overlay__container__left__nav__current'),
                    slideshowTopSharebar: $overlay.find('.slideshow-overlay__header__share'),
                    slideSideSharebar: $overlay.find('.slideshow-overlay__container__left__side-share'),
                    slideIndex: 1,
                    mobile: false,
                    desktop: true
                };
            }
        });

        window.addEventListener('keyup', navigateSlides, false);
    };

    var navigateSlides = function (e) {
        if (_currentSlideshow && _currentSlideshow.desktop) {
            switch (e.keyCode) {
                case 27:
                    // escape key
                    _currentSlideshow.slideshowOverlay.find('.slideshow-overlay__header__close').click();
                    break;
                case 37:
                    // left arrow
                    _currentSlideshow.slideshowOverlay.find('.slideshow-overlay__container__left__nav__prev').click();
                    break;
                case 39:
                    // right arrow
                    _currentSlideshow.slideshowOverlay.find('.slideshow-overlay__container__left__nav__next').click();
                    break;
            }
        }
    };

    var setSlideShareURL = function (currentUrl, ss) {
        // we add a query string when sharing slideshow urls so that
        // the rails controller can know when we're in slideshow view mode on load
        // (controller can't read hashes, they're not passed to the server)
        var slideshowQueryString = window.Mobileweb.getQueryStringParameter(currentUrl, "slideshow") === undefined ? (currentUrl.indexOf("?") !== -1 ? "&slideshow=true" : "?slideshow=true") : "";
        return currentUrl + slideshowQueryString + "#gallery/" + ss.slid + "/" + ss.slideIndex;
    };

    var initializeEmbeds = function (provider, container) {
        // Initialize embeds if needed.
        if (!provider) return;

        if (provider == 'instagram' && window.instgrm) {
            window.instgrm.Embeds.process();
        } else if (provider == 'twitter' && window.twttr) {
            window.twttr.ready(function () {
                twttr.widgets.load(container);
            });
        }
    };

    var goToSlide = function (ss) {
        var slide = ss.data[ss.slideIndex - 1];
        var preload = ss.preloads[ss.slideIndex - 1];

        if (preload.length && preload.html && typeof preload.html === 'function') {
            ss.slideContainer.empty().append(preload);
        } else {
            ss.slideContainer.html(slide.content);
        }

        initializeEmbeds(slide.provider, ss.slideContainer);

        if (ss.desktop) {
            var slideTitle = (slide.type === 'quote') ? (slide.credits || slide.credit) : slide.title;
            var slideCaption = slide.text || slide.caption || '';
            var slideCredits = (slide.type === 'quote') ? (slide.credits || slide.credit) : '';

            ss.slideTitle.html(slideTitle);
            ss.slideCaption.html(slideCaption);
            ss.slideCredit.html(slide.credits || slide.credit);
            ss.slideCounter.html(ss.slideIndex);

            ss.slideCaption.find('a').addClass('entry__link--omit');

            $(document).trigger('reloadAd', ss.topAd);
            $(document).trigger('reloadAd', ss.sideAd);
        }

        trackSlideshow(ss, slide);
        preloadNextTwoSlides(ss); //pre-load next two slides if they are images

        var newUrl = setSlideShareURL(currentUrl, ss);
        window.history.replaceState(null, null, newUrl);

        $(document).trigger('slideshow:gotoSlide', {slideshow: ss});

        if (ss.desktop) {
            //set sharebar individual slide data
            ss.slideSideSharebar.data('sharingimage', slide.image || slide.image_url_large || '');
            ss.slideSideSharebar.data('sharingurl', newUrl);
        }
    };

    var listAllSlides = function (ss) {
        var $div;
        var $listicle;
        var innerSlideshow;
        var $modal = $('#modal');

        if ($modal.find('.listicle').length < 1) {
            innerSlideshow = _innerSlideshowContainer;
            $div = $('<div/>');

            innerSlideshow = innerSlideshow.replace(/\%\%slideshowId\%\%/g, ss.slid);
            innerSlideshow = innerSlideshow.replace(/\%\%slideshowHeadline\%\%/g, ss.overlayTitle.text());
            $div.append($(innerSlideshow));

            $modal.find('.modal__content').html($div.html());

            // Track loaded mobile slideshow
            MW.modules.rapid.trackElements($modal);
        }

        if (ss.preloads && ss.preloads.length > 0) {
            ss.slideContainer = $modal.find('.listicle');
            ss.slideContainer.empty();

            var counter = 1;
            ss.preloads.forEach(function (preload) {
                ss.slideContainer.append(preload.html());
                if (ss.mobile === true && ss.adCode) {
                    if (counter % 5 === 0) { //add placeholders for slideshow ads
                        ss.slideContainer.append($('<div/>', {
                            'id': 'mobileweb_instream_square_' + ss.slid + '_' + (counter / 5),
                            'class': 'advertisement mobileweb_instream_square treated reactive_ad_spot',
                            'data-adcode': ss.adCode
                        }));
                    }
                }
                counter++;
            });

            if (ss.mobile === true) {
                $(document).trigger("render:mw-slideshow-ads", {"slideshow_id": ss.slid});
            }

            if (!ss.slideContainer.hasClass('scroll-tracking-enabled')) {
                ss.slideContainer.addClass('scroll-tracking-enabled');
                MW.modules.Tracky.addSlidePVs($modal, true);
            }
        }
    };

    var trackSlideshow = function (ss, currentSlide) {
        MW.events.publish("tracking_slide_pv", {
            type: "slides_ajax",
            sub_type: 'gallery',
            slideshow_id: ss.slid,
            id: currentSlide.id || currentSlide._id || '',
            pos: ss.slideIndex,
            length: ss.slideCount,
            credit: currentSlide.credit || currentSlide.credits || '',
            slide_type: currentSlide.type,
            slide_filename: currentSlide.image || currentSlide.image_url_large || ''
        });
    };

    var preloadNextTwoSlides = function (ss) {
        for (var i = 1; i < 3; i++) {
            if (ss.slideIndex + i < ss.slideCount - 1) {
                var preload = ss.preloads[ss.slideIndex + i];
                var slide = ss.data[ss.slideIndex + i];

                if (!preload.html() && slide.type == 'image') {
                    preload.html(ss.data[ss.slideIndex + i].content);
                }
            }
        }
    };

    var openSlideShow = function (sid, slid, onLoad) {
        var ss = slideshows[sid];
        _currentSlideshow = ss;

        if (ss) {
            ss.slideIndex = slid;
            ss.slideshowOverlay.removeClass('hidden');
            $('body').addClass('mobileweb b-page no-scroll');
            $(document).trigger('slideshow:open', {slideshow: ss});

            if (ss.desktop && modulousQueue) {
                modulousQueue.add(function () {
                    ss.topAd.html(Mobileweb.ads.slideshowTop);
                    ss.sideAd.html(Mobileweb.ads.slideshowLeft);
                });
            }

            if (!ss.data) {
                Promise.resolve($.ajaxTraced(ss.dataUrl))
                    .then(function (data) {
                        if (data.slides) {
                            ss.data = data.slides;
                            updateOverlayTitle(ss, data.title);
                            createPreloads(ss);
                            updateSlideCount(ss, data.slides.length);

                            if (ss.desktop) {
                                goToSlide(ss);
                                displaySlideCount(ss, data.length);
                            } else {
                                listAllSlides(ss);
                            }
                        }
                    });
            } else {
                if (ss.desktop) {
                    goToSlide(ss);
                } else {
                    listAllSlides(ss);
                }
            }

            if (ss.desktop) {
                if (!ss.slideshowTopSharebar.attr('data-sharingurl')) {
                    //set sharingurl to slideshow first slide one time
                    ss.slideshowTopSharebar.data('sharingurl', setSlideShareURL(currentUrl, ss));
                }
            }
        }
    };

    var updateOverlayTitle = function (ss, title) {
        ss.overlayTitle.html(title);
    };

    var updateSlideCount = function (ss, count) {
        ss.slideCount = count;
    };

    var displaySlideCount = function (ss, count) {
        ss.slideCountTotal.html(count);
    };

    var createPreloads = function (ss) {
        ss.preloads = [];

        if (ss.desktop) {
            ss.data.forEach(function (slide) {
                var $container = $('<div></div>');
                $container.addClass('slide-type-' + slide.type.replace(/[^a-z0-9-]/gi, ''));

                if (slide.provider) {
                    $container.addClass('slide-provider-' + slide.provider.replace(/[^a-z0-9-]/gi, ''));
                }

                $container.html(slide.content);

                ss.preloads.push($container);
            });
        } else {
            ss.data.forEach(function (slide, idx) {
                var embed;
                var item = _listicle;
                var $div = $('<div/>');

                item = item.replace(/\%\%key\%\%/g, idx);
                item = item.replace(/\%\%keyPlus\%\%/g, idx + 1);
                item = item.replace(/\%\%slideCaption\%\%/g, slide.caption || '');
                item = item.replace(/\%\%slideCredit\%\%/g, slide.credit || '');
                item = item.replace(/\%\%slideId\%\%/g, slide.id || '');

                if (slide.type === 'image') {
                    item = item.replace(/\%\%slideImage\%\%/g, slide.image_url_large || '');
                }

                item = item.replace(/\%\%slideTitle\%\%/g, slide.title || '');

                $div.append($(item));

                if (slide.type !== 'image') {
                    $div.find('.share-bar').remove();
                    var $container = $div.find('.listicle__image');

                    $container.replaceWith(slide.content || '');

                    initializeEmbeds(slide.provider, $container);
                }

                ss.preloads.push($div);
            });
        }
    };

    var checkSlideshowParams = function () {
        // CHECK FOR SLIDESHOW PARAMS
        currentUrl = window.location.href;
        var hash = currentUrl.indexOf("#");
        var slideshowHashParts, slideshowId, slideId;

        if (hash !== -1) {
            slideshowHashParts = currentUrl.substring(hash + 9, currentUrl.length).split('/');
            slideshowId = slideshowHashParts[0];
            slideId = slideshowHashParts[1];
            currentUrl = currentUrl.substring(0, hash);
            openSlideShow(slideshowId, parseInt(slideId, 10), true);
        }
    };

    // Init
    initSlideshows();
    checkSlideshowParams();

    // Event listeners
    $('.slideshow').click(function (e) {
        var $target = $(e.target);
        var $slideshowOverlay = $(this).find('.slideshow-overlay');

        // this will get bubble-up click event from overlay, we have to check if event is not from inside overlay
        if ($target.parents('.slideshow-overlay').length === 0 && $slideshowOverlay.css('display') === 'none') {
            openSlideShow($(this).attr("data-slideshow-id"), 1);
        }
    });

    $('.slideshow-thumb-img').click(function (e) {
        var $container = $(this).parents('a');
        $('#modal').removeClass('hidden');
        openSlideShow($container.attr("data-slideshow-id"), 1);
    });

    $('.slideshow-overlay__header__close').click(function (e) {
        var ss = slideshows[$(this).attr('data-slideshow-id')].slideshowOverlay.addClass('hidden');
        window.history.replaceState(null, null, currentUrl);
        $('body').removeClass('mobileweb b-page no-scroll');
    });

    $('.slideshow-overlay__container__left__nav__prev').click(function (e) {
        var ss = slideshows[$(this).attr('data-slideshow-id')];

        if (ss.slideIndex > 1) {
            ss.slideIndex--;
            goToSlide(ss);
        }
    });

    $('.slideshow-overlay__container__left__nav__next').click(function (e) {
        var ss = slideshows[$(this).attr('data-slideshow-id')];

        if (ss.slideIndex < ss.slideCount) {
            ss.slideIndex++;
            goToSlide(ss);
        }
    });

}());
